<mbm-modal id="logout-sheet" titleKey="general.logout" (modalClose)="onCancel()">
  <ng-container slot="modal-content">
    <div class="logout-user">
      <mbm-avatar [name]="userName()" size="lg"></mbm-avatar>
      <div class="logout-user-text">
        <div class="logout-user-name">{{ userName() }}</div>
        @if (userCompany()) {
          <div class="logout-user-company">{{ userCompany() }}</div>
        }
      </div>
    </div>
  </ng-container>
  <ng-container slot="modal-footer">
    <div class="logout-actions">
      <mbm-button id="logout-cancel-btn" variant="outline" textKey="general.cancel" (buttonClick)="onCancel()"></mbm-button>
      <mbm-button id="logout-confirm-btn" variant="dark" textKey="general.logout" (buttonClick)="onLogout()"></mbm-button>
    </div>
  </ng-container>
</mbm-modal>
